import Component from 'vue-class-component';
import Vue from 'vue';

export const defaultDateTimeFormat = 'MMMM DD, YYYY';
@Component({})
export class Date extends Vue {
  //TODO: set dateformat based on browser language
  defaultDateTimeFormat = defaultDateTimeFormat;
}
